<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-lg-12 col-lg-3 vcenter">
      <h3>Environmental Config</h3>
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />

  <mat-tab-group>
    <mat-tab label="Waste Types">

      <aims-common-table
        id="wasteTypeConfigTable"
        [dataSource]="wasteTypes | async"
        [defaultTableState] = "{ sort:{ active : 'wasteType', direction: 'asc' }}"
        [header]="wasteTypeTableColumns"
        [permissions]="wasteTypeTablePermissions | async"
        [addRowInitialObject]="initialWasteType"
        (rowUpdated)="handleWasteTypeRowUpdate($event)"
        (rowAdded)="handleWasteTypeRowUpdate($event)"
        [stickyHeader]="true"
        [pageSize]="15"
      >
      </aims-common-table>
    </mat-tab>

    <mat-tab label="Waste Container Types">
      <aims-common-table
        id="wasteContainerTypeConfigTable"
        [dataSource]="wasteContainerTypes | async"
        [defaultTableState] = "{ sort:{ active : 'containerTypeId', direction: 'asc' }}"
        [header]="wasteContainerTypeTableColumns"
        [permissions]="wasteContainerTypeTablePermissions | async"
        [addRowInitialObject]="initialWasteContainerType"
        (rowUpdated)="handleWasteContainerTypeRowUpdate($event)"
        (rowAdded)="handleWasteContainerTypeRowUpdate($event)"
        [stickyHeader]="true"
        [pageSize]="15"
      >
        <aims-common-table-dynamic-row id="maxAmount">
          <ng-template viewMode let-element >
            {{ element.maxAmount | currency: "USD":"symbol":"1.2-4" }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl" >
            <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" [formControl]="dynamicControl" name="maxamt" [min]="0"></aims-numeric>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </mat-tab>
  </mat-tab-group>
</div>
